/** Pay app editor step routing — must stay in sync with PayAppEditorModal. */
export const PAYAPP_EDITOR_STEP_LABELS = [
  'Period info',
  'Change orders',
  'Billing grid',
  'Attachments',
  'Review & send',
] as const

export const PAYAPP_EDITOR_TOTAL_STEPS = PAYAPP_EDITOR_STEP_LABELS.length

export function parseEditorStepFromUrl(raw: string | null | undefined): number {
  const n = parseInt(raw ?? '5', 10)
  if (!Number.isFinite(n)) return 5
  return Math.min(Math.max(n, 1), PAYAPP_EDITOR_TOTAL_STEPS)
}

/** Existing pay apps (draft or submitted) open at Review; only brand-new uses step 1. */
export function payAppEditorStep(pa: {
  status: string
  submitted_at?: string | null
  payment_status?: string | null
}): number {
  void pa
  return 5
}

/** Next step after period info — always change orders (step 2). */
export function stepAfterPeriodInfo(): number {
  return 2
}
